import Vue from 'vue';
import Vuex, { Store, Plugin } from 'vuex';
import createLogger from 'vuex/dist/logger';
import quickSearch from './modules/quick-search';
import vinSearch from './modules/vin-search';
import partSearch from './modules/part-search';
import partCatalogueSearch from './modules/part-catalogue-search';
import countryStateSelect from './modules/country-state-select';
import shoppingCart from './modules/shopping-cart';
import notification from './modules/notification';
import ordersForUser from './modules/orders-for-user';
import relatedParts from './modules/related-parts';
import { RootState } from './rootState';
import shoppingCartUpload from './modules/shopping-cart-upload';
import carParts from './modules/car-parts';

Vue.config.devtools = process.env.VUE_APP_MODE === 'dev';

Vue.use(Vuex);

const plugins: Array<Plugin<RootState>> = [];

if (process.env.VUE_APP_MODE === 'dev') {
    plugins.push(createLogger());
}

// module name must match name of the namespace
export default new Store<RootState>({
    modules: {
        quickSearch,
        vinSearch,
        partSearch,
        partCatalogueSearch,
        countryStateSelect,
        shoppingCart,
        notification,
        ordersForUser,
        relatedParts,
        shoppingCartUpload,
        carParts,
    },
    plugins,
});
